import React from "react";
import { handleOutsideClick } from "../../../Helpers/HandleOutsideClick";

const AddMasterDataModal = ({
  show,
  onClose,
  displayTitle,
  addValue,
  setAddValue,
  selectedParent,
  setSelectedParent,
  dropdownList,
  type,
  onSubmit,
}) => {
  if (!show) return null;

  const lowerType = type.toLowerCase();

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 px-4"
      onClick={(e) => handleOutsideClick(e, onClose)}
    >
      <div className="bg-white w-full max-w-md rounded-xl shadow-2xl p-6">

        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold text-[#0467c5]">
            Add {displayTitle}
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-black text-xl"
          >
            ✕
          </button>
        </div>

        {/* Dropdown for Departments */}
        {lowerType === "departments" && (
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1">
              Select Function
            </label>
            <select
              value={selectedParent}
              onChange={(e) => setSelectedParent(e.target.value)}
              className="w-full border rounded-md p-2 focus:outline-none focus:ring-2 border-blue-200 focus:ring-blue-300"
            >
              <option value="">-- Select Function --</option>
              {dropdownList.map((f) => (
                <option key={f.functionID} value={f.functionID}>
                  {f.functionName}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* Dropdown for Job Locations */}
        {(lowerType === "joblocations" ||
          lowerType === "job-location" ||
          lowerType === "job-locations") && (
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1">
              Select Zone
            </label>
            <select
              value={selectedParent}
              onChange={(e) => setSelectedParent(e.target.value)}
              className="w-full border rounded-md p-2 focus:outline-none focus:ring-2 border-blue-200 focus:ring-blue-300"
            >
              <option value="">-- Select Zone --</option>
              {dropdownList.map((z) => (
                <option key={z.zoneID} value={z.zoneID}>
                  {z.zoneName}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* Name Input */}
        <div className="mb-6">
          <label className="block text-sm font-medium mb-1">
            {displayTitle} Name
          </label>
          <input
            type="text"
            value={addValue}
            onChange={(e) => setAddValue(e.target.value)}
            className="w-full border rounded-md p-2 focus:outline-none focus:ring-2 border-blue-200 focus:ring-blue-300"
            placeholder={`Enter ${displayTitle}`}
          />
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 rounded-md"
          >
            Cancel
          </button>

          <button
            onClick={onSubmit}
            className="px-6 py-2 bg-primary text-white rounded-md"
          >
            Add {displayTitle}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddMasterDataModal;
